import { render } from "./icon_loading.vue?vue&type=template&id=21cfc7bb&scoped=true"
import script from "./icon_loading.vue?vue&type=script&lang=js"
export * from "./icon_loading.vue?vue&type=script&lang=js"

import "./icon_loading.vue?vue&type=style&index=0&id=21cfc7bb&scoped=true&lang=css"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cfc7bb"]])

export default __exports__